//
//
//
//
//
//
//
//

import CdnBackgroundImage from "../Image/CdnBackgroundImage";
import CdnImagePropsMixin from "../Image/CdnImagePropsMixin";

export default {
    name: "CardImage",
    mixins: [CdnImagePropsMixin],

    components: {CdnBackgroundImage},

    props: {

        // The dimension data of the image it will be displayed
        size: {
            type: Object,
            default: () => {return {width: 280, ratio: 4/2}}
        },

        // The gradient of the background image
        gradient: String,

        blur: Number
    },

}
